export const IS_SELLER = "type";
export const CREATION_DATE = "documentDate";
export const CREATION_PLACE = "documentPlace";
export const FIO = "sellerFullName";
export const PASSPORT_NUMBER = "sellerPassportNumber";
export const PASSPORT_SERIES = "sellerPassportSeries";
export const PASSPORT_DATE = "sellerPassportIssueDate";
export const PASSPORT_CODE = "sellerDivisionCode";
export const PASSPORT_ISSUER = "sellerPassportIssuePlace";
export const PASSPORT_BIRTHDAY = "sellerBirthDate";
export const PASSPORT_ADDRESS = "sellerAddress";
export const CUSTOMER_FIO = "buyerFullName";
export const CUSTOMER_PASSPORT_SERIES = "buyerPassportSeries";
export const CUSTOMER_PASSPORT_NUMBER = "buyerPassportNumber";
export const CUSTOMER_PASSPORT_DATE = "buyerPassportIssueDate";
export const CUSTOMER_PASSPORT_CODE = "buyerDivisionCode";
export const CUSTOMER_PASSPORT_ISSUER = "buyerPassportIssuePlace";
export const CUSTOMER_PASSPORT_BIRTHDAY = "buyerBirthDate";
export const CUSTOMER_PASSPORT_ADDRESS = "buyerAddress";
export const CAR_MODEL = "vehicleBrandAndModel";
export const CAR_VIN = "vehicleVin";
export const CAR_TYPE = "vehicleCategory";
export const CAR_YEAR = "vehicleYear";
export const CAR_MILEAGE = "vehicleMileage";
export const CAR_ENGINE_POWER = "vehicleHorsePower";
export const CAR_ENGINE_VOLUME = "vehicleDisplacement";
export const CAR_COLOR = "vehicleColor";
export const CAR_ENGINE_MODEL = "CAR_ENGINE_MODEL";
export const CAR_ENGINE_NUMBER = "vehicleEngineNumber";
export const CAR_FRAME_NUMBER = "vehicleFrameNumber";
export const CAR_BODY_NUMBER = "vehicleBodyNumber";
export const PTC_SERIES = "vehiclePtsSeries";
export const PTS_NUMBER = "vehiclePtsNumber";
export const PTC_DATE = "vehiclePtsIssueDate";
export const PTC_ISSUER = "vehiclePtsIssuePlace";
export const CAR_NUMBER = "vehicleRegistrationNumber";
export const STS_SERIES = "vehicleStsSeries";
export const STS_NUMBER = "vehicleStsNumber";
export const STS_DATE = "vehicleStsIssueDate";
export const STS_ISSUER = "vehicleStsIssuePlace";
export const CAR_PRICE = "vehiclePrice";
export const CAR_ENGINE_OIL = "engineOil";
export const DAMAGE_DESCRIPTION = "damageDescription";
export const ACCEPTANCE_CERT_DATE = "transferActDate";